export enum DIALOGS {
    PERSISTENCE_AVATAR = 'PERSISTENCE_AVATAR',
    PERSISTENCE_COVER = 'PERSISTENCE_COVER',
    SAVE_TO_COLLECTION_DIALOG_NAME = 'saveToCollection',
    PROMOTE_SHOW_IN_FEED_COLLECTION_DIALOG_NAME = 'promoteShowInFeedCollection',
    DELETE_FROM_COLLECTION_DIALOG_NAME = 'deleteFromCollection',
    SUBSCRIPTIONS = 'SUBSCRIPTIONS',
    EDIT_COLLECTION = 'EDIT_COLLECTION',
    CREATE_INVITE = 'CREATE_INVITE',
    REPORT_DIALOG = 'REPORT_DIALOG',
    OFFER_AGREEMENT = 'OFFER_AGREEMENT,',
    WITHOUT_RANGE = 'WITHOUT_RANGE',
    SELECT_CATEGORIES = 'SELECT_CATEGORIES',
    POST_PRODUCTS = 'POST_PRODUCTS',
    APPS_QR = 'APPS_QR',
    ADD_PRODUCT = 'ADD_PRODUCT',
    COLLECTION_STATUS = 'COLLECTION_STATUS',
    ADD_POST_DIALOG = 'ADD_POST_DIALOG',
    POST_STATUS = 'POST_STATUS',
    OTHER_MENU_OPTIONS = 'OTHER_MENU_OPTIONS',
    CREATE_COLLECTION = 'CREATE_COLLECTION',
    CREATE_COLLECTION_FROM_POSTS = 'CREATE_COLLECTION_FROM_POSTS',
    DIRECT_AUTHORIZATION = 'DIRECT_AUTHORIZATION',
    CPA_TRIAL = 'CPA_TRIAL',
    CPA_TRIAL_REGISTRATION = 'CPA_TRIAL_REGISTRATION',
    CPA_ACCEPTED = 'CPA_ACCEPTED',
    CPA_WAIT_REGISTRATION = 'CPA_WAIT_REGISTRATION',
    CPA_DECLINED = 'CPA_DECLINED',
    CPA_MODERATION = 'CPA_MODERATION',
    CPA_ADVERTISING_PRODUCTS_INFO = 'CPA_ADVERTISING_PRODUCTS_INFO',
    CPA_ADVERTISING_SHOPS_INFO = 'CPA_ADVERTISING_SHOPS_INFO',
}

export const DEFAULT_CLOSE_ANIMATION_DELAY = 150;

export const INTELLECTUAL_PROPERTY_VIOLATION_REPORT_URL =
    'https://yandex.ru/support2/rythm/ru/violation-report';

export const ADVERTISING_CATALOG_URL = '/advertising/catalog';
